/**
 * Author(s) : Jerry Oswin
 * Purpose : This is a Menu Component for navigating to different routes.
 */
import styles from "./NavMenu.module.scss";
import React from 'react';
import ToggleEffect from "../toggleEffect/ToggleEffect";
import { NAVIGATION_MENU, THEMECONSTANTS, VIEWPORT_BREAKPOINTS } from '../../constants';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { NavLink } from 'react-router-dom';
import useViewport from "../../hooks/useViewport";
import PropTypes from 'prop-types';

const NavMenu = (props) => {

    const { setHamburgerOpen, handleTheme, theme } = props;
    
    // To get viewport width
    const { viewportWidth } = useViewport();

    return (
        <div className={styles.menuContainer}>
            <nav>
                <ul className={styles.navContents}>
                    {NAVIGATION_MENU.map((navigationLink, index) => (
                        <NavLink to={navigationLink.NAVIGATION} key={index} className={({ isActive }) => (isActive ? `${viewportWidth <= VIEWPORT_BREAKPOINTS.LARGE_SIZE_MOBILE_DEVICES ? styles.overlayNav : styles.activeNav}` : styles.inactiveNav)}>
                            <li className={styles.menuItems} 
                                onClick={() => {
                                    if(viewportWidth <= VIEWPORT_BREAKPOINTS.LARGE_SIZE_MOBILE_DEVICES)
                                        setHamburgerOpen(false);
                                }}
                            >
                                <div className={styles.navIconContainer}>
                                    <FontAwesomeIcon icon={navigationLink.ICON} size = '1x'/>
                                </div>
                                <h5>{navigationLink.HEADING}</h5>
                            </li>
                        </NavLink>
                    ))}
                    <li className={styles.themeToggle}>
                        <div className={styles.navIconContainer}>
                            <FontAwesomeIcon icon={THEMECONSTANTS.ICON}/>
                        </div>
                        <h5>{THEMECONSTANTS.HEADING}</h5>
                        <ToggleEffect handleTheme={handleTheme} theme={theme}></ToggleEffect>
                    </li>
                </ul>
            </nav>
        </div>
    );
};

export default React.memo(NavMenu);

//Proptypes for Homepage component
NavMenu.propTypes = {
    setHamburgerOpen: PropTypes.func.isRequired,
    handleTheme:PropTypes.func.isRequired,
    theme:PropTypes.string.isRequired
  };